const WEEKDAYS = ['月', '火', '水', '木', '金', '土', '日'];

export { WEEKDAYS };

